import React, { CSSProperties } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ContractsScreen from '../screens/ContractsScreen';
import { colors } from '../colors';
import { AuthenticatedUserContext } from '../providers';
import { UserContextType } from '../@types/user';

export const AppStack = () => {
  const { user, setUser } = React.useContext(AuthenticatedUserContext) as UserContextType;
  
  const headerStyle: CSSProperties = {
    backgroundImage: 'url(https://images.unsplash.com/photo-1550338861-b7cfeaf8ffd8?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1594&q=80)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: colors.white,
    padding: '20px',
    fontSize: '25px',
    borderBottom: `1px solid ${colors.slate}`,
    flex: '0 0 auto',
  };

  const contentStyle: CSSProperties = {
    flex: '1 1 auto',
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  };

  return (
    <>
      <header style={headerStyle}>
        <h1 style={{ margin: 0, fontSize: '25px' }}>Administración de Recibos de Agua</h1>
      </header>
      <div style={contentStyle}>
        <Routes>
          <Route path="/contracts" element={<ContractsScreen />} />
          <Route path="*" element={<Navigate to="/contracts" replace />} />
        </Routes>
      </div>
    </>
  );
};